var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      "enableBackground": "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.9,131.6c0-8.5-1.9-19-10.4-19c-3.2,0.2-6,2-7.6,4.7c-4.7,8.5-7.6,35.1,6.6,73 C239.1,171.4,243,151.6,243.9,131.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.6,387.7c-1.2,3.2,0,6.7,2.8,8.5c1.7,1.1,3.7,1.7,5.7,1.9c12.3,0,35.1-22.8,56.9-58.8 C130.1,356.4,105.4,374.4,102.6,387.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224,301.4L224,301.4c22.8-7.6,52.2-13.3,52.2-14.2c-11.4-11.9-21.6-24.9-30.4-38.9 C239.5,266.3,232.2,284.1,224,301.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.9,0H78.1C35,0,0,35,0,78.1v343.8C0,465,35,500,78.1,500h343.8c43.1,0,78.1-35,78.1-78.1V78.1 C500,35,465,0,421.9,0z M412.7,324.1c-2.8,8.5-11.4,18-34.1,18c-17.1,0-49.3-4.7-86.3-37c-28,5.4-55.5,12.7-82.5,21.8 c-23.7,40.8-57.9,89.2-93,89.2c-8.7,0.1-17.1-3-23.7-8.5c-6.5-6-9.4-15-7.6-23.7c4.7-28.5,62.6-55,90.1-66.4 c18.6-34.6,34.1-70.8,46.5-108.1c-18-40.8-22.8-80.6-11.4-100.5c4.8-8,13.4-13,22.8-13.3c26.6,0,36,25.6,36,49.3 c-1.2,26.8-6.3,53.4-15.2,78.7c12.5,21.8,27.8,41.9,45.5,59.8c16.1-1.9,83.5-12.3,108.1,13.3C415.1,303.9,417,314.9,412.7,324.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371,296.6c-19.9-3.8-47.4-0.9-59.8,0.9c14.2,11.5,30.7,19.9,48.4,24.7c15.2,3.8,23.7-2.8,24.7-9.5 C386.2,303.3,378.6,298.5,371,296.6z"
  })));
};

export default __webpack_public_path__ + "static/media/pdf.b5230b4e.svg";
export { SvgComponent as ReactComponent };